export default {
  administrador: 1,
  procurador: 2,
  socioPFMenosDez: 3,
  socioPFDezMais: 4,
  socioPJEstrangeira: 5,
  socioPJNacional: 6,
};
